import { PermissionsEnum } from "@/auth/interfaces";
import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import {
  BucketAwtENUM,
  EstadoPreventaEnum,
  gridSizeMdLg12,
  hasPermission, ModulosEnumChoice,
  ROUTER_PATHS, TABLE_CONSTANTS,
  texto,
  useTableFilter, useTableServerSideFiltering,
  useUploadFile
} from "@/shared";
import { CustomAutocompleteNoForm, GeneralTable, useModalMotivoRechazo } from "@/shared/components/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import { useUiStore } from "@/store/ui";
import { useFetchPutPreventaPymes, useGetPreventasPymes } from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import { useTableColumnsPreventaPymes } from "../../hook/useTableColumnsPreventaPymes";
import { InfoPuntoEnlace, IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import VisibilityIcon from '@mui/icons-material/Visibility';
interface TablePreventaPymesProps {
  estado_preventa: EstadoPreventaEnum
  enable_action?: boolean
  pre_requiere_contrato_fisico?: boolean
}

export default function TablePreventaPymes({
  estado_preventa,
  enable_action = true,
  pre_requiere_contrato_fisico = false,
}: TablePreventaPymesProps) {

  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);
  const [openModalEnlace, setOpenModalEnlace] = useState(false);
  const [contratoFile, setContratoFile] = useState<File | null>(null);
  const [dataPreventa, setDataPreventa] = useState<IPreventaPymes | null>(null);
  const [selectEnlace, setSelectEnlace] = useState<string | null>(null);

  const {
    mutateAsync: mutateAsyncPutPreventa
  } = useFetchPutPreventaPymes({})

  const {
    handleUploadFile
  } = useUploadFile();

  const setAlert = useUiStore(s => s.setAlert)

  ///* Hook
  const { columnsPreventa } = useTableColumnsPreventaPymes(estado_preventa);

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREVENTA_PYMES
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const queryParams = {
    estado_preventa: estado_preventa,
    es_pyme: true,
    pre_requiere_contrato_fisico,
    //requiere_contrato_fisico: false,
    identificacion: searchTerm,
    page: pageIndex + 1,
    page_size: pageSize,
    fecha_preventa_before: dateBefore,
    fecha_preventa_after: dateAfter,
    user_create: vendedor,
    ...filterObject,
    filterByState: false
  };

  console.log('[TablePreventaPymes] Query params:', queryParams);

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventasPymes(queryParams);

  console.log('[TablePreventaPymes] Preventas recibidas:', preventasRes?.data.data?.length || 0, 'items');
  console.log('[TablePreventaPymes] Estado filtro:', estado_preventa);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}

            setVendedor={setVendedor}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaPymes>
            columns={columnsPreventa}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // // actions
            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={false}
            enableEditing={enable_action}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            showCustomActionBtnSpace={enable_action}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container>
                    {
                      value.estado_aceptacion && value.estado_preventa == EstadoPreventaEnum.EN_ESPERA && (
                        <Grid item >
                          <Tooltip placement='top' title='Puntos Enlace'>
                            <IconButton
                              onClick={() => {

                                const dataFilter = {
                                  ...value,
                                  coordenadas: value.coordenadas.filter(e => e.estado == false),

                                }
                                setDataPreventa(dataFilter)
                                setOpenModalEnlace(true)
                              }}
                            >
                              <VisibilityIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      )
                    }
                    {value.pre_requiere_contrato_fisico && (
                      <Grid item >
                        <Tooltip placement='top' title='Cargar contrato'>
                          <IconButton
                            onClick={() => {
                              setOpenModal(true)
                              setDataPreventa(value)
                            }}
                          >
                            <DriveFolderUploadIcon color="primary" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )

                    }
                    {
                      hasPermission(PermissionsEnum.api_change_preventapymes) && (
                        <>
                          <Grid item>
                            <Tooltip title={texto.cancelado} placement="top">
                              <IconButton
                                color="error"
                                onClick={() => {
                                  useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar una Preventa del cliente ${value.prospecto_pymes_data.razon_social} con identificación ${value.prospecto_pymes_data.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                                  useHookModalMotivoRechazo.setModalCancelar(true)
                                  useHookModalMotivoRechazo.reset({
                                    id: value.id_preventa_pymes,
                                    identificacion: value.prospecto_pymes_data.identificacion,
                                    razon_social: value.prospecto_pymes_data.razon_social,
                                    observaciones: value.observaciones
                                  })
                                }
                                }
                              >
                                <HighlightOffIcon />
                              </IconButton>
                            </Tooltip>
                          </Grid>

                        </>
                      )
                    }
                  </Grid>
                </>
              )
            }
            }

          />
        </Grid>
      </Grid>

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

      {/* Seleccionar el punto de enlace */}

      <ScrollableDialogProps
        onCloseIcon={() => setOpenModalEnlace(false)}
        open={openModalEnlace}
        title="Puntos de enlace"
        dialogContentText={`Seleccionar un punto de enlace para continuar con el preagendamiento.`}
        showConfirmBtn={true}
        confirmVariantBtn={'contained'}
        onClose={() => {
          setOpenModalEnlace(false)
        }}
        onConfirm={async () => {

          if (!dataPreventa || !selectEnlace) return;
          //console.log(`${ROUTER_PATHS.ventasPymes.preagendamientoCreateNav}/${dataPreventa!.id_preventa_pymes}/${selectEnlace}`);
          navigate(`${ROUTER_PATHS.ventasPymes.preagendamientoCreateNav}/${dataPreventa!.id_preventa_pymes}/${selectEnlace}`);

        }}
        confirmTextBtn={'Continuar'}
        contentNode={
          <Grid container>
            <CustomAutocompleteNoForm<InfoPuntoEnlace>
              label="Enlace"
              // options
              options={dataPreventa?.coordenadas.map(e => {
                return {
                  ...e,
                  nombre: `${e.nombre}`
                }
              }) || []}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              isLoadingData={false}
              onChangeValue={(value) => {

                setSelectEnlace(value)

              }}
              size={gridSizeMdLg12}
            />
          </Grid>
        }
      />


      {/* Cargar el contrato fisico */}

      <ScrollableDialogProps
        onCloseIcon={() => setOpenModal(false)}
        open={openModal}
        title="Cargar documento"
        dialogContentText={`Por favor, suba el contrato firmado por el representante legal o la persona autorizada. Una vez cargado, el departamento correspondiente revisará el documento. Le recomendamos mantenerse atento a cualquier notificación.`}
        showConfirmBtn={true}
        confirmVariantBtn={'contained'}
        onClose={() => {
          setOpenModal(false);
          setContratoFile(null);
        }}
        onConfirm={async () => {

          if (!contratoFile)
            return setAlert(true, 'Subir contrato.', AlertSeverityEnum.info);

          if (!dataPreventa)
            return setAlert(true, 'No se encontro preventa.', AlertSeverityEnum.info);

          if (!dataPreventa.contrato_data)
            return setAlert(true, 'No se encontro contrato.', AlertSeverityEnum.info);

          setOpenModal(false)

          const contratoFisico = await handleUploadFile(contratoFile, BucketAwtENUM.CONTRATO_FISICO)

          await mutateAsyncPutPreventa({
            id: dataPreventa.id_preventa_pymes!,
            data: {
              pre_requiere_contrato_fisico: false,
              requiere_contrato_fisico: true,
              url_contrato: contratoFisico.url,
            }
          })


        }}
        confirmTextBtn={'Guardar'}
        contentNode={
          <>
            <CargarDocumentoSoluccionCosteada
              idInput='documento-preventa'
              buttonText={'Contrato firmado'}
              selectedImage={contratoFile}
              setSelectedImage={setContratoFile}
            />
          </>
        }
      />
    </>
  )

}